import styled from "styled-components";

export const Button = styled.button`
  width: 100%;
  outline: none;
  border: none;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  color: ${({ theme }) => theme.colors.secondarytextcolor};
  background-color: ${({ theme }) => theme.colors.primary};
  font-weight: 500;
  height: 40px;
  margin-top: 2em;
  padding: 10px 16px;
  text-align: center;
  transition: transform 100ms;
  outline: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;

  :hover {
    transform: scale(1.05);
    mix-blend-mode: darken;
    background-image: linear-gradient(rgba(0, 0, 0, 0.08) 0 0);
  }
 
`;

export const NavButton = styled(Button)`
  width: 80px;
  margin: 0;
  border: none;
  box-shadow: none;
  border-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  border-width: 1px;
  border-style: solid;
  background-color: ${({ theme }) => theme.colors.secondarytextcolor};
  display:flex;
  align-items:center;
  justify-content:center;
`;

export const WhiteButton = styled(Button)`
  border-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  border-width: 1px;
  border-style: solid;
  background-color: ${({ theme }) => theme.colors.secondarytextcolor};
  display: flex;
  align-items: center;
  justify-content:center;
`;


export const ViewAllProjectsButton = styled(Button)`
width:100%;
margin-bottom:2em;
`


